import { z } from "zod";

const EMAIL_REGEX = /^[a-zA-Z0-9._'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,20}$/;
export const ForgotPasswordSchema = z.object({
  email: z
    .string()
    .min(1, "Email can not be blank")
    .refine((val) => EMAIL_REGEX.test(val), {
      message: "Provided value should be a valid email",
    }),
})
